// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { memo, useCallback, useEffect, useState } from "react";

import { mdiCamera } from "@mdi/js";

import { ToolbarButton } from "components/base";
import { useDashboardDispatch } from "components/dashboard/hooks";
import { useScreenshotContext, useScreenshotDispatch } from "components/screenshot/hooks";

interface VisScreenshotToggleProps {
  onToggle?: (a) => void;
  /** Which KIND of viewer this is, which decides the widget component type. */
  type: string;
  /**
   * Which viewer this is. Defaults to the kind, which is what a dashboard
   * widget has always used - and is why a second viewer of the same kind, the
   * well card's, went into screenshot mode alongside it. A host that mounts
   * one beside a widget passes its own.
   */
  widgetId?: string;
}

const VisScreenshotToggle = ({
  onToggle,
  type,
  widgetId = type
}: VisScreenshotToggleProps) => {
  const screenshotDispatch = useScreenshotDispatch();
  const dashboardDispatch = useDashboardDispatch();
  const { settings, widget } = useScreenshotContext();

  const [screenshotOverlayVisible, setScreenshotOverlayVisible] = useState(false);

  useEffect(() => {
    const screenshotActive = widget?.widgetId === widgetId;
    setScreenshotOverlayVisible(screenshotActive);
  }, [settings, widget]);

  useEffect(() => {
    const typeToComponentType = {
      ml: "threeDViewer",
      xda: "xdaViewer"
    };

    const componentType = typeToComponentType[type];

    const widget = screenshotOverlayVisible
      ? {
          widgetId,
          widgetComponentType: componentType
        }
      : null;

    screenshotDispatch({
      payload: {
        widget
      }
    });
  }, [screenshotDispatch, screenshotOverlayVisible]);

  const toggleScreenshot = useCallback(() => {
    setScreenshotOverlayVisible(!screenshotOverlayVisible);
    dashboardDispatch({ payload: { lockMap: screenshotOverlayVisible } }); //lock map
    onToggle && onToggle(screenshotOverlayVisible);
  }, [screenshotOverlayVisible]);

  return (
    <ToolbarButton
      key="Screenshot"
      active={screenshotOverlayVisible}
      icon={<Icon path={mdiCamera} size={1.5} />}
      tooltipText="Screenshot"
      overflowLabel="Screenshot"
      data-testid="vis-screenshot-toggle"
      onToggle={toggleScreenshot}
      styleKey="threeDVToolbar"
    />
  );
};

export default memo(VisScreenshotToggle);
